import BundleVersionDAO from '../../modules/distribution/components/bundle/version/DAO/BundleVersionDAO';

export default class StopBundleVersionDistributionsService {

    constructor(JFrogModal, JFrogEventBus, JFrogNotifications, bundleVersionDAO) {
        this.modal = JFrogModal;
        this.jFrogEventBus = JFrogEventBus;
        this.EVENTS = JFrogEventBus.getEventsDefinition();
        this.jfrogNotifications = JFrogNotifications;
        this.bundleVersionResource = bundleVersionDAO.Resource;
    }

    stopDistribution(daoParams) {
        this.daoParams = daoParams;
        this.modal
                .confirm(
                        `Stop all ongoing distributions of version ${this.daoParams.release_bundle_version} of release bundle ${this.daoParams.release_bundle} ?`,
                        'Stop Dsitribution', {confirm: 'Stop'})
                .then(() => {
                    this.stop()
                });
    }

    stop() {
        this.bundleVersionResource
                .stopReleaseBundleVersionDistributions(this.daoParams, {}).$promise.then(() => {
            this.jFrogEventBus.dispatch(this.EVENTS.DISTRIBUTION_STOPPED);
        });
    }
}

StopBundleVersionDistributionsService.META = {
    name: 'StopBundleVersionDistributionsService'
};

StopBundleVersionDistributionsService.$inject = [
    'JFrogModal',
    'JFrogEventBus',
    'JFrogNotifications',
    BundleVersionDAO.META.name
];



// WEBPACK FOOTER //
// ./modules/distribution/services/stopBundleVersionDistributions/stop.bundle.versions.distributions.service.js